import type { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { getPixelInREM, getResponsiveWidth } from 'common/material'

export const SOCIAL_ICON_DIMENSIONS = 25

export const useStyles = makeStyles((theme: Theme) => ({
    page: {
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        flexFlow: 'row nowrap',
        backgroundColor: theme.custom.colors.backgrounds.hard,
        justifyContent: 'flex-start'
    },
    container: {
        position: 'relative',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        overflowY: 'auto',
        width: '100%'
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.custom.colors.oxfordBlue,
        height: '30%',
        alignItems: 'flex-start',
        padding: getPixelInREM(10)
    },
    contentContainer: {
        position: 'absolute',
        // keep original (MUI4) vertical spacing on Upload/static pages
        top: '18%',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '2vh 5vh',
        backgroundColor: 'white',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: theme.spacing(1),
        maxHeight: '70%',
        width: '70%',
        ...getResponsiveWidth(theme, '40%', '70%', '90%')
    },
    title: {
        marginBottom: '3vh',
        marginTop: '2vh',
        color: theme.custom.colors.oxfordBlue,
        fontWeight: 600
    },
    emailLink: {
        color: theme.custom.colors.oxfordBlue,
        '& a': {
            textDecoration: 'underline',
            fontWeight: 600
        }
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '3vh',
        flexDirection: 'column'
    },
    socialMediaContainer: {
        width: '10%',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginTop: theme.spacing(1)
    },
    address: {
        color: theme.custom.colors.darkGrey,
        fontWeight: 500,
        marginBottom: '2vh',
        marginTop: '3vh'
    },
    divider: {
        color: theme.custom.colors.oxfordBlue,
        width: '50%'
    },
    goBackButton: {
        display: 'flex',
        alignSelf: 'center',
        justifyContent: 'center',
        width: '50%',
        marginBottom: '2vh',
        color: theme.custom.colors.oxfordBlue,
        backgroundColor: theme.custom.colors.chartreuseGreen,
        '&:hover': {
            color: 'white'
        }
    }
}))

export const useStaticPageStyles = makeStyles<Theme>((theme) => ({
    contentContainer: {
        ...getResponsiveWidth(theme, '90%', '90%', '90%'),
        overflow: 'hidden'
    }
}))
